import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.status === null
        ? _c(
            VCard,
            [
              _c(
                VCardTitle,
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("m2301.detailButtons.title")) +
                      "\n      "
                  ),
                  _c(VSpacer),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCardText,
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { staticClass: "ma-4" },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "py-8",
                              attrs: {
                                color: "primary",
                                width: 200,
                                block: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.status = "APPROVED"
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("m2301.detailButtons.approved")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.notRefund
                        ? _c(
                            VCol,
                            { staticClass: "ma-4" },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "py-8",
                                  attrs: {
                                    color: "warning",
                                    width: 200,
                                    block: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.status = "AMENDMENT"
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("m2301.detailButtons.amendment")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        VCol,
                        { staticClass: "ma-4" },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "py-8",
                              attrs: { color: "error", width: 200, block: "" },
                              on: {
                                click: function ($event) {
                                  _vm.status = "REJECTED"
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("m2301.detailButtons.rejected")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.status !== null
        ? _c(
            VCard,
            [
              _c(
                VCardTitle,
                [
                  _c("h2", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("m2301.detailButtons.title")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(VSpacer),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCardText,
                { staticClass: "px-0" },
                [
                  _c(
                    VRow,
                    { staticClass: "mx-4 mt-4" },
                    [
                      _c(VAutocomplete, {
                        staticClass: "col-md-2",
                        attrs: {
                          label: _vm.$t("m2301.detailButtons.status"),
                          items: _vm.notRefund
                            ? _vm.statusItemsDefault
                            : _vm.statusItemsRefund,
                          "item-text": "label",
                          "item-value": "value",
                          outlined: "",
                        },
                        model: {
                          value: _vm.status,
                          callback: function ($$v) {
                            _vm.status = $$v
                          },
                          expression: "status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(VRow, { staticClass: "mx-4" }, [
                    _c("h3", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.noticeText[_vm.status]) +
                          "\n        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    VRow,
                    { staticClass: "ma-4" },
                    [
                      _c(
                        VForm,
                        {
                          ref: "form",
                          staticClass: "full-width-form",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.updateApprovalStatus()
                            },
                          },
                          model: {
                            value: _vm.formIsValid,
                            callback: function ($$v) {
                              _vm.formIsValid = $$v
                            },
                            expression: "formIsValid",
                          },
                        },
                        [
                          _c(
                            VCol,
                            [
                              _c(
                                VRow,
                                [
                                  _vm.status === "REJECTED"
                                    ? _c(VAutocomplete, {
                                        staticClass: "required",
                                        attrs: {
                                          label: _vm.$t(
                                            "m2301.detailButtons.category"
                                          ),
                                          items: _vm.rejectCategory,
                                          "item-text":
                                            "translated_category_name",
                                          rules: [
                                            (v) =>
                                              !!_vm.selectedIndex ||
                                              _vm.$t(
                                                "m2301.rules.categoryRequired"
                                              ),
                                          ],
                                          "item-value": "id",
                                          outlined: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "item-container",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.translated_category_name
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.translated_category_desc
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1240268828
                                        ),
                                        model: {
                                          value: _vm.selectedIndex,
                                          callback: function ($$v) {
                                            _vm.selectedIndex = $$v
                                          },
                                          expression: "selectedIndex",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                VRow,
                                [
                                  _c(VTextarea, {
                                    class:
                                      _vm.status !== "APPROVED"
                                        ? "required"
                                        : null,
                                    attrs: {
                                      label: _vm.$t(
                                        "m2301.detailButtons.verdict"
                                      ),
                                      rules: [
                                        (v) =>
                                          !(
                                            v === "" &&
                                            (_vm.status === "REJECTED" ||
                                              _vm.status === "AMENDMENT")
                                          ) ||
                                          _vm.$t("m2301.rules.verdictRequired"),
                                      ],
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.verdict,
                                      callback: function ($$v) {
                                        _vm.verdict = $$v
                                      },
                                      expression: "verdict",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            VCol,
                            {
                              staticClass: "buttonContainer pt-0 pr-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    color: "primary",
                                    width: 200,
                                    block: "",
                                    type: "submit",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("m2301.detailButtons.submit")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }